import lottie from "lottie-web";
import { CLASSES } from "@/scripts/helpers/constants";
import { animatePersonLeft, animatePersonRight } from "@/scripts/animation-data/animateReleaseNotes";
import modalShow from "@/modules/containers/modal/modal";
import contactForm from "@/modules/blocks/contact-form/index";
import customSelectTrigger from "@/pages/release-notes/navigation-list";
import Tabs from "@/pages/release-notes/tabs";

const animateClassPerson = ".js-ready-animate-person";

let animateWasPlayedFlag4 = false;

const inView = function(element) {
  const win = $(window),
        obj = element,
        scrollPosition = win.scrollTop(),
        visibleArea = win.scrollTop() + win.height(),
        objEndPos = obj.offset().top;

  return visibleArea >= objEndPos && scrollPosition <= objEndPos;
};

const dataAnimatePersonLeft = () => {
  let params = {
    container: document.getElementById("animatePersonLeft"),
    renderer: 'canvas',
    loop: false,
    autoplay: true,
    animationData: animatePersonLeft
  };

  let anim;
  anim = lottie.loadAnimation(params);
};

const dataAnimatePersonRight = () => {
  let params = {
    container: document.getElementById("animatePersonRight"),
    renderer: 'canvas',
    loop: false,
    autoplay: true,
    animationData: animatePersonRight
  };

  let anim;
  anim = lottie.loadAnimation(params);
};

const startAnimatePerson = () => {
  const animatePerson = document.querySelector(animateClassPerson);

  if (animatePerson !== null) {
    if (!animateWasPlayedFlag4 && inView($(animatePerson))) {
      dataAnimatePersonLeft();
      dataAnimatePersonRight();
      animateWasPlayedFlag4 = true;
    }

    window.addEventListener("scroll", event => {
     if (!animateWasPlayedFlag4 && inView($(animatePerson))) {
        dataAnimatePersonLeft();
        dataAnimatePersonRight();
        animateWasPlayedFlag4 = true;
      }
    });
  }
};

const showMoreReleases = () => {
  const cardsList = $(".release-notes-list");

  if ( cardsList.length ) {
    cardsList.ready(function() {
      function hideItems(triggerBlockClass) {
        const triggerBlock = $(triggerBlockClass);

        let i = 0;

        triggerBlock.each(function() {
          i += 1;

          if (i > 4) {
            $(this).addClass(CLASSES.IS_HIDDEN);
          }
        });
      }

      hideItems("#tab1 .release-notes");
      hideItems("#tab2 .release-notes");

      if ($("#tab1 .release-notes").length <= 4) {
        $("#tab1 .releases__show-more").addClass(CLASSES.IS_HIDDEN);
      }
      if ($("#tab2 .release-notes").length <= 4) {
        $("#tab2 .releases__show-more").addClass(CLASSES.IS_HIDDEN);
      }

      $("#tab1 .js-show-more-link").on("click", function(e) {
        e.preventDefault();
        
        const blocksHidden = $("#tab1 .release-notes"),
              showMoreBtn = $("#tab1 .link--show-more");

        $(this).text($(this).text() == "Show more" ? "Show less" : "Show more");    

        blocksHidden.each(function() {
          $(this).not(":nth-child(-n+4)").toggleClass(CLASSES.IS_HIDDEN);
        });

        const ItemHidden = $("#tab1 .release-notes.is-hidden");

        if (ItemHidden.length < 1 && !$(this).hasClass("is-active")) {
          showMoreBtn.addClass("is-active");
        } else {
          showMoreBtn.removeClass("is-active");
          $("html, body").animate(
            {
              scrollTop: showMoreBtn.offset().top - 280
            },
            200
          );
        }
      });

      $("#tab2 .js-show-more-link").on("click", function(e) {
        e.preventDefault();

        const blocksHidden = $("#tab2 .release-notes"),
              showMoreBtn = $("#tab2 .link--show-more");

        $(this).text($(this).text() == "Show more" ? "Show less" : "Show more");

        blocksHidden.each(function() {
          $(this).not(":nth-child(-n+4)").toggleClass(CLASSES.IS_HIDDEN);
        });

        const ItemHidden = $("#tab2 .release-notes.is-hidden");

        if (ItemHidden.length < 1 && !$(this).hasClass("is-active")) {
          showMoreBtn.addClass("is-active");
        } else {
          showMoreBtn.removeClass("is-active");
          $("html, body").animate(
            {
              scrollTop: showMoreBtn.offset().top - 230
            },
            200
          );
        }
      });
    });
  };
};

$(document).ready(function () {
  startAnimatePerson();
  modalShow();
  contactForm();
  customSelectTrigger();
  Tabs();
  showMoreReleases();

  $("[data-micromodal-trigger]").click(function(e) {
    e.preventDefault();
  });
});
